/**
 * Generated by orval v8.19.0 🍺
 * Do not edit manually.
 * Catalog Api
 * REST api
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  VariantJsonldVariantRead,
  VariantJsonldVariantWrite,
  VariantVariantWrite
} from './schemas';

import { apiCatalog } from '../../apiCatalog';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type variant_postResponse201 = {
  data: VariantJsonldVariantRead
  status: 201
}

export type variant_postResponse400 = {
  data: void
  status: 400
}

export type variant_postResponse422 = {
  data: void
  status: 422
}

export type variant_postResponseSuccess = (variant_postResponse201) & {
  headers: Headers;
};
export type variant_postResponseError = (variant_postResponse400 | variant_postResponse422) & {
  headers: Headers;
};

export type variant_postResponse = (variant_postResponseSuccess | variant_postResponseError)

export const getVariantPostUrl = () => {




  return `/api/variant`
}

/**
 * Creates a Variant resource.
 * @summary Creates a Variant resource.
 */
export const variant_post = async (variantPostBody: VariantJsonldVariantWrite | VariantVariantWrite, options?: RequestInit): Promise<variant_postResponse> => {

  return apiCatalog<variant_postResponse>(getVariantPostUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: JSON.stringify(variantPostBody)
  }
);}





export const getVariantPostMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof variant_post>>, TError,{data: VariantJsonldVariantWrite | VariantVariantWrite}, TContext>, request?: SecondParameter<typeof apiCatalog>}
): UseMutationOptions<Awaited<ReturnType<typeof variant_post>>, TError,{data: VariantJsonldVariantWrite | VariantVariantWrite}, TContext> => {

const mutationKey = ['variantPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof variant_post>>, {data: VariantJsonldVariantWrite | VariantVariantWrite}> = (props) => {
          const {data} = props ?? {};

          return  variant_post(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VariantPostMutationResult = NonNullable<Awaited<ReturnType<typeof variant_post>>>
    export type VariantPostMutationBody = VariantJsonldVariantWrite | VariantVariantWrite
    export type VariantPostMutationError = void

    /**
 * @summary Creates a Variant resource.
 */
export const useVariantPost = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof variant_post>>, TError,{data: VariantJsonldVariantWrite | VariantVariantWrite}, TContext>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof variant_post>>,
        TError,
        {data: VariantJsonldVariantWrite | VariantVariantWrite},
        TContext
      > => {
      return useMutation(getVariantPostMutationOptions(options), queryClient);
    }
    export type variant_patchResponse200 = {
  data: VariantJsonldVariantRead
  status: 200
}

export type variant_patchResponse400 = {
  data: void
  status: 400
}

export type variant_patchResponse404 = {
  data: void
  status: 404
}

export type variant_patchResponse422 = {
  data: void
  status: 422
}

export type variant_patchResponseSuccess = (variant_patchResponse200) & {
  headers: Headers;
};
export type variant_patchResponseError = (variant_patchResponse400 | variant_patchResponse404 | variant_patchResponse422) & {
  headers: Headers;
};

export type variant_patchResponse = (variant_patchResponseSuccess | variant_patchResponseError)

export const getVariantPatchUrl = (id: string,) => {




  return `/api/variant/${id}`
}

/**
 * Updates the Variant resource.
 * @summary Updates the Variant resource.
 */
export const variant_patch = async (id: string,
    variantVariantWrite: VariantVariantWrite, options?: RequestInit): Promise<variant_patchResponse> => {

  return apiCatalog<variant_patchResponse>(getVariantPatchUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/merge-patch+json', ...options?.headers },
    body: JSON.stringify(variantVariantWrite)
  }
);}





export const getVariantPatchMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof variant_patch>>, TError,{id: string;data: VariantVariantWrite}, TContext>, request?: SecondParameter<typeof apiCatalog>}
): UseMutationOptions<Awaited<ReturnType<typeof variant_patch>>, TError,{id: string;data: VariantVariantWrite}, TContext> => {

const mutationKey = ['variantPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof variant_patch>>, {id: string;data: VariantVariantWrite}> = (props) => {
          const {id,data} = props ?? {};

          return  variant_patch(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VariantPatchMutationResult = NonNullable<Awaited<ReturnType<typeof variant_patch>>>
    export type VariantPatchMutationBody = VariantVariantWrite
    export type VariantPatchMutationError = void

    /**
 * @summary Updates the Variant resource.
 */
export const useVariantPatch = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof variant_patch>>, TError,{id: string;data: VariantVariantWrite}, TContext>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof variant_patch>>,
        TError,
        {id: string;data: VariantVariantWrite},
        TContext
      > => {
      return useMutation(getVariantPatchMutationOptions(options), queryClient);
    }
    export type variant_getResponse200 = {
  data: VariantJsonldVariantRead
  status: 200
}

export type variant_getResponse404 = {
  data: void
  status: 404
}

export type variant_getResponseSuccess = (variant_getResponse200) & {
  headers: Headers;
};
export type variant_getResponseError = (variant_getResponse404) & {
  headers: Headers;
};

export type variant_getResponse = (variant_getResponseSuccess | variant_getResponseError)

export const getVariantGetUrl = (id: string,) => {




  return `/api/variants/${id}`
}

/**
 * Retrieves a Variant resource.
 * @summary Retrieves a Variant resource.
 */
export const variant_get = async (id: string, options?: RequestInit): Promise<variant_getResponse> => {

  return apiCatalog<variant_getResponse>(getVariantGetUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVariantGetQueryKey = (id: string,) => {
    return [
    `/api/variants/${id}`
    ] as const;
    }


export const getVariantGetQueryOptions = <TData = Awaited<ReturnType<typeof variant_get>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof variant_get>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVariantGetQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof variant_get>>> = ({ signal }) => variant_get(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof variant_get>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VariantGetQueryResult = NonNullable<Awaited<ReturnType<typeof variant_get>>>
export type VariantGetQueryError = void


export function useVariantGet<TData = Awaited<ReturnType<typeof variant_get>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof variant_get>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof variant_get>>,
          TError,
          Awaited<ReturnType<typeof variant_get>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVariantGet<TData = Awaited<ReturnType<typeof variant_get>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof variant_get>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof variant_get>>,
          TError,
          Awaited<ReturnType<typeof variant_get>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVariantGet<TData = Awaited<ReturnType<typeof variant_get>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof variant_get>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a Variant resource.
 */

export function useVariantGet<TData = Awaited<ReturnType<typeof variant_get>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof variant_get>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVariantGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






